export const MARKETS = {
  dk: { countryId: "DK", languageId: "da", hreflang: "da-DK" },
  se: { countryId: "SE", languageId: "sv", hreflang: "sv-SE" },
  gb: { countryId: "GB", languageId: "en", hreflang: "en-GB" },
};

export const marketFromPath = (pathname = "") => {
  const key = String(pathname).split("/").filter(Boolean)[0]?.toLowerCase();
  return key && MARKETS[key] ? { key, ...MARKETS[key] } : null;
};

export const marketFromCountryId = (countryId = "") =>
  Object.entries(MARKETS).find(([, market]) => market.countryId === String(countryId).toUpperCase())?.[0] || "";

export const withMarketPath = (pathname, path = "/") => {
  const market = marketFromPath(pathname);
  if (!market) return path;
  const suffix = path.startsWith("/") ? path : `/${path}`;
  return `/${market.key}${suffix === "/" ? "/" : suffix}`;
};